import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { sp } from 'styles/theme';
import mixins from 'styles/mixins';

const HeroText = styled.div`
  ${mixins.heroText};
  margin-bottom: ${sp.xl};

  h1 {
    font-size: inherit;
  }
`;

const propTypes = {
  heading: PropTypes.string.isRequired,
};

function StaticHero({ heading }) {
  return (
    <HeroText>
      <h1>{heading}</h1>
    </HeroText>
  );
}

StaticHero.propTypes = propTypes;

export default StaticHero;



// WEBPACK FOOTER //
// ./src/components/shared/StaticHero/StaticHero.jsx